import {
  // BiBrain,
  BiAward,
  BiBuildingHouse,
  BiGitPullRequest,
  BiSearchAlt,
  BiSpreadsheet,
  BiStats,
  BiSupport,
} from "react-icons/bi";
import {
  FaAcquisitionsIncorporated,
  FaBiohazard,
  FaLeaf,
  FaMoneyBill,
  FaRegBuilding,
  FaRobot,
} from "react-icons/fa";

import {
  MdAltRoute,
  MdDataExploration,
  MdLightbulbOutline,
  MdOutlineBugReport,
} from "react-icons/md";

export const message = {
  welcomeText: "Welcome to ",
  petrochem: "Petrochem Bangladesh Ltd",
};

export const partners = {
  businessPartner: [
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Capture-1_yspRAAyaiB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156042",
      name: "FMC",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Untitled-1_VFDjL9tBB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156019",
      name: "DU Point",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Capture1_KlmjMQfClG.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156063",
      name: "NUFARM",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Asiatic-Agricultural-Industries-Pte.-Ltd.-300x300-1_DfQB4L0aUS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246155968",
      name: "Asiatic Agriculture",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Capture2_sie35o7rZz.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246650266",
      name: "Sinon",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Untitled-2_SPwmkr7gI.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246155843",
      name: "know",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Capture6_tY7hFLeyj.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246155475",
      name: "Dalian Chem Group",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Capture4_AG0gSwD_G.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156328",
      name: "UPL",
    },
  ],

  financialPartners: [
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/AB-BANK-LOGO_yuTCp7wfa-.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246154065",
      name: "AB Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/bank-logo3_srkBQKVL_9.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153673",
      name: "Sonali Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Untitled-1-1_7WDTbwxBCV.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153705",
      name: "Dhaka Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/krishi_NjgtBAFOHd.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153838",
      name: "Bangladesh Krishi Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/brac__1__gl3boDB-iY.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675251373769",
      name: "Brac bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/national-bank-limited_IvVQzXnvk.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153267",
      name: "National Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/images-3_n6oTeOl0v.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153193",
      name: "Islami Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/IFIC-Bank-01_nwM7_8wNhB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153567",
      name: "IFIC bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/dbbl_LILQ3BZMq.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153067",
      name: "DBBL Bank",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/1513582845__3__rdv6mQGgk.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675312094622",
      name: "City Bank",
    },
  ],

  developmentPartners: [
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Untitled-1-2_FMnytdnyy.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246153373",
      name: "M4C",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/BRRI__1__NvC5wr0-FU.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675251637685",
      name: "BRRI",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/cim_xDNuSHleFl.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150906",
      name: "CIMMYT",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/gmark_1hfpimxYts.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150912",
      name: "gymark",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/logo3_r0N0cX5lm6.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150842",
      name: "EDGE",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/Untitled_tcY4cWFWxg.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150871",
      name: "KATALYST",
    },
  ],

  communicationPartners: [
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/gp_aUCpvHJ-Hl.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150826",
      name: "grameenphone",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/share_image_robi__1__ZrqGdj05u.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675312199027",
      name: "Robi",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/agni_nc8eC7hAb.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150739",
      name: "banglalink",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/agni_nc8eC7hAb.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246150739",
      name: "agni ",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/trackit-logo__1__VZC3edm3W.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675312293621",
      name: "track IT Limited",
    },
  ],

  mediaPartners: [
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/atn_VNyiKHjYw.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156388",
      name: "ATN Bangla ",
    },
    {
      imagesrc:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/cr_jhinuk_TQ2r75jlb.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675246156244",
      name: "Jhinuk ",
    },
  ],
};

export const missionList = [
  {
    id: 1,
    mission:
      "To attain the vision we devote our resources to provide products and services of high and consistent quality which ensure value for money to our customers.",
  },
  {
    id: 2,
    mission:
      "To create an image as suppliers of quality products and services.",
  },
  {
    id: 3,
    mission:
      "To ensure productivity of its operations and encourage innovative abilities of its employees.",
  },
  {
    id: 4,
    mission:
      "To ensure superior return on investment through healthy and sustainable growth of the Company.",
  },
  {
    id: 5,
    mission:
      "To contribute to the personal development and well being of our employees.",
  },
  {
    id: 6,
    mission:
      "To encourage and support qualitative improvement of the services of our distributors and suppliers.",
  },
  {
    id: 7,
    mission:
      "To participate in selected Govt./NGO Projects and in community services for the attainment of social goals.",
  },
  {
    id: 8,
    mission:
      "To become a model as a responsible corporate citizen of our country.",
  },
  {
    id: 9,
    mission:
      "To be able to have sustainable growth without disturbing the nature and continuous improvement in HSE",
  },
];

export const coreValue = [
  {
    id: 1,
    title: "Quality",
    description: "Contributing to the growth of key sectors of Bangladesh",
    imagesrc:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/quality_uXgkszQzn.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326366671",
  },
  {
    id: 2,
    title: "Innovation",
    description: "Petrochem always innovate latest technology in agro industry",
    imagesrc:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/launch_sPIbbxNch.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326362366",
  },
  {
    id: 3,
    title: "Safety",
    description:
      "We ensure the maximum safety for the nature and e co friendly products",
    imagesrc:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/shield_ZLN85bCV0.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326362922",
  },
  {
    id: 4,
    title: "Eco friendly",
    description: "We are echo friendly certified company in Bangladesh",
    imagesrc:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/world__1__AiAPxIWyP.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326366015",
  },
];

export const flicpcard = {
  data1: {
    title: "History",
    subtitle: "At a glance",
    description:
      "Petrochem Group, one of the leading group of companies in Bangladesh, established in 1990 but over the time has become one of the renowned business conglomerates in the country. ",
  },
  data2: {
    title: "Award",
    subtitle: "Winning Performance",
    description:
      "Petrochem ( Bangladesh ) Limited earned  Hundreds of Best Awards in the sector of agriculture. ",
  },
  data3: {
    title: "Technology",
    subtitle: "Advanced Tech",
    description:
      "Petrochem ( Bangladesh ) Limited is most advanced in technology from any other Agro-Chemical Industries in Bangladesh.  ",
  },
};

export const chairmanMessage = {
  title:
    "We’re a global stakeholder relations and partnership building consultancy.",
  message:
    "Mr. A.B.A. SirajUddowlah, Former Managing Director of Petrochem (Bangladesh) Ltd., is a senior Agriculturist in Bangladesh. He obtained B. Ag. Degree from Dhaka University in 1959 and M. Sc. Degree from American University of Beirut in 1962. He graduated in Law (LLB) in 1970. He started his career in 1963 as Manager, James Finlay’s Tea Garden at Srimongol. He was the Resident Director of Sarma Chemical Works and Huqson’s Laboratories, Comilla, from 1968-75. Mr. Dowlah was Managing Director of The Shell Company of Bangladesh Ltd. from 1976 to 1990. In 1990, he started his own business in the name & style of “Petrochem (BD) Ltd” and later, expanded the business further by entering into other areas through the establishment of business concerns like “International Services (BD) Ltd.” and “Habitat Builders Ltd.” With a successful career in key positions of reputed national and international corporations & having a wide range of experience, Mr. Dowlah is well known in business circle dealing with oil products, chemical fertilizers as well as Real Estate business. He had been associated with various chamber of commerce and industries in Bangladesh. He died on February -10, 2019.",
  signame: "Late A.B. A. Siraj Uddowlah",
  designation: "EX-Chairman and founder",
};

export const facilitydetails = [
  {
    id: 1,
    title: "30+ YEARS OF EXPERTISE",
    icon: <FaAcquisitionsIncorporated />,
  },
  {
    id: 2,
    title: "ISO 9001 : 2015 CERTIFIED",
    icon: <BiAward />,
  },
  {
    id: 4,
    title: "300+ PRODUCT RANGE",
    icon: <BiSpreadsheet />,
  },
  {
    id: 5,
    title: "IN-HOUSE R&D FACILITY",
    icon: <BiSearchAlt />,
  },
  {
    id: 6,
    title: "DISTRIBUTION NETWORK",
    icon: <BiGitPullRequest />,
  },
  {
    id: 7,
    title: "MANUFACTURING FACILITIES",
    icon: <BiBuildingHouse />,
  },
  {
    id: 8,
    title: "Farmer Service and Support",
    icon: <BiSupport />,
  },
  {
    id: 9,
    title: "IN-HOUSE R&D FACILITY",
    icon: <BiStats />,
  },
];

export const sustainability = {
  data1: {
    image:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/world_9iYr8AgL5c.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326364596",
    title: "Environment",
    message:
      "The major environmental challenges faced by Bangladesh agriculture include, how to conserve our basic agricultural assets such as land, water, and biodiversity and how to make agriculture sustainable? Farming is sensitive to short term and long term climate changes. Both of these kinds of changes affect farming directly (due to change in temperature, precipitation and/or CO2 levels) and indirectly (through changes in soil, distribution and frequency of infestation by pests, insects, diseases or weeds). These environmental issues have already affected many crops in India. To handle these challenges, attention needs to be paid to soil, irrigation water, nutrients, crops and their management practices, to sustain the productivity and to ensure food and environmental security to the country. Petrochem (Bangladesh) limited is working on these issues and spreading information amongst farmers. Petrochem (Bangladesh) is regularly encouraging good agricultural practices such as use of modern technologies, optimum use of fertilizers and green manure according to soil test report for better soil health, crop insurance, use of hybrid seeds, judicious use of agrochemicals, saving water in agriculture through use of drip irrigation and sprinkler irrigation technique etc. Petrochem (Bangladesh) limited is also educating farmers not to burn crop residue in field.",
  },
  data2: {
    image:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/safety_uF8nhfFKy.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675326362479",
    title: "Safety",
    message:
      "Safety An estimated 1.3 billion workers are engaged in agricultural production worldwide. This represents half of the total world labour force. Only 9% of agricultural workers are in industrialized countries. Almost 60% of them are in developing countries. A great majority of agricultural workers are found in Asia, which is the most densely populated region of the world, with more than 40% of the world's agricultural population concentrated in China and more than 20% in Petrochem Bangladesh Limited under its aspiration “Transforming Bangladesh through Agriculture” is highlighting their approach of providing end-to-end farming solutions through training and educating farmers. Under this approach, the company aims to minimize the crop losses and improve crop yield. PCL is also distributing safety kits to farmers for personal protection and encourage good agricultural practices during their farmers meetings and other programs.",
  },
  data3: {
    image:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/WWD_img_HdZQDlXDV.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675326364561",
    title: "World Water Day",
    message:
      "World Water Day image 4 World Water Day It was nearly a decade ago recognizing the impending scarcity of water, Petrochem ( Bangladesh) Limited came up with a massive campaign to create mass awareness about conservation and judicious use of water in Bangladesh . The Company is extremely happy to note that organization’s vision has been beautifully aligned with Government of Bangladesh’s agenda regarding water conservation for irrigation. The Government of Bangladesh recognizes the importance of Water Conservation, Micro-irrigation, Watershed Development. Every year since 2010 Petrochem ( Bangladesh) Limited is celebrating World Water Day on 22nd of March in partnership with prestigious National Institutes, Bangladesh Agricultural Universities etc. where lectures on water conservation & reuse of water are organized. In addition to this, drawing competition on ‘Conservation of Water’ theme in schools is undertaken.",
  },
};

export const basicflex = {
  data1: {
    title: "Corporate Social Responsibility",
    message:
      "Petrochem (Bangladesh) Limited is always providing support to unprivileged people of the society. Petrochem strives to realize better life, health and happiness for people by being integral members of society, sharing common values, and proposing new values through its business activities. In this spirit, Petrochem (Bangladesh) Limited was set up as the CSR (Corporate Social Responsibility) wing with a view of endowing various charitable causes for the benefit of the society in general, and especially for the less privileged for their education, healthcare and other amenities.",
  },
};

export const tabData = [
  {
    label: "Education Sector",
    content: (
      <div>
        <p className="text-gray-700 py-4">
          Petrochem is providing financial support to unprivileged people. We
          provided support for higher education as well as basic education in
          primary and high school level.{" "}
        </p>
        <div className="flex gap-3">
          <div>
            <img
              className="w-auto"
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/download-4-300x149_rIwrCHzg45.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675855120987"
              alt="child"
            />
          </div>
          <div>
            <img
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/bangladesh-educational-curriculum-300x300_W0qHV8CPjZ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675855121215"
              alt=""
            />
          </div>
        </div>
      </div>
    ),
  },
  {
    label: "Emergency Disaster",
    content: (
      <div>
        <p className="text-gray-700 py-4">
          We are helping emergency disaster affected people. We provided
          supports in emergency disaster in national level as well as
          international level. Petrochem provided relief and financial support
          to earthquake affected people of Nepal.
        </p>
        <div className="flex gap-3">
          <div>
            <img
              className="w-auto"
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/earthquake8-300x300_g9sHVHeXz.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675855121165"
              alt="child"
            />
          </div>
          <div>
            <img
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/earthquake5-300x300_oqxW7Y7aIz.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675855121185"
              alt=""
            />
          </div>
        </div>
      </div>
    ),
  },
  {
    label: "Environment Sector",
    content: (
      <div>
        <p className="text-gray-700 py-4">
          We always encourage green solution. We are providing support for green
          renewable energy solution. We are developing awareness to save our
          environment. We motivated more than five thousand farmers to use
          environmental friendly agricultural inputs.
        </p>
        <div className="flex gap-3">
          <div>
            <img
              className="w-auto"
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/qwqw_vROox3-Ze.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675855123816"
              alt="child"
            />
          </div>
        </div>
      </div>
    ),
  },
  {
    label: "Social Sector",
    content: (
      <div>
        <p className="text-gray-700 py-4">
          We provided financial supports to unprivileged people of the society.
          We provided aid to build & development of Mosque, Library, Road and
          Home. From our aid lots of people overcome their poverty.
        </p>
        <div className="flex gap-3">
          <div>
            <img
              className="w-auto"
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/edwwsd-300x300_dNTq-SbEg.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675855122172"
              alt="child"
            />
          </div>
          <div>
            <img
              src="https://ik.imagekit.io/txh5evivcha5/pclstatic/qwqwqwq-300x300_ePHi5KKUlu.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675855122337"
              alt=""
            />
          </div>
        </div>
      </div>
    ),
  },
];

export const whoweare = {
  maiintitle: "We are best Agro-Chemical company in Bangladesh",
  leftdescription:
    "Petrochem Group, one of the leading group of companies in Bangladesh, established in 1990 but over the time has become one of the renowned business conglomerates in the country. Initially it was a dream of A B A Siraj Uddowlah, but after a long journey of 30 years, Petrochem Group has made a breakthrough in its strong foundation and business diversifying in Agro Sector, Power & Energy Sector, Real Estate Sector, Information Technology Sector, Chemical Sector etc. In the private sector, Petrochem Group is a name of Conglomerate with its sister organizations like Petrochem (Bangladesh) Limited, Petrochem Agro-Industries Limited, Petro Product (Bangladesh) Limited, Bangla Solar IT Limited, Habitat Builders Limited, International Services (Bangladesh) Limited, Solar Power Limited.",
  rightdescription:
    " Petrochem now a brand in the Agro, Power & Energy, Real Estate, Information Technology and Chemical Sector of Bangladesh has successfully created enormous opportunity of employment for the vibrant and visionary educated human resources. Petrochem mission is to achieve business excellence through quality by understanding, accepting, meeting and exceeding customer expectations. Petrochem follows International standard on quality management system to ensure consistent quality of product and service to achieve customers’ satisfaction.",
  rightsmalldesc:
    "Petrochem has been contributing greatly to the economy, GDP and also a vibrant tax payer of Bangladesh. Petrochem is playing a humanitarian role through contribution in the line of CSR (Corporate Social Responsibility).",
  cmtitle: "FOREWORDS FROM THE MANAGING DIRECTOR AND FOUNDER CHAIRMAN:",
  cmmessage:
    "Since my childhood, I adored nature and its beauty and studied Agriculture. On completion of my M.S. in Agronomy, Seed Technology and Entomology, at the American University of Beirut, I returned home and joined James Finlay as a Tea Planter in Sylhet. Thereafter I worked in Pharmaceutical Company for six years before joining Shell Petroleum Company. So I became an oil man, looking after both marketing as well as exploration of Oil and Gas. Despite being the Managing Director and Shell Representative in Bangladesh, I craved to pursue my own trade, which was agriculture and not Petroleum. ",
  extramessage:
    "Thus, I started Petrochem (Bangladesh) Ltd. in 1990 in a humble way. Today, I remember with great respect those colleagues who helped me to take this company forward, but left this world before the completion of 30 years of this company. They are Mr. M.M. Alam, Mr. Jashimuddin, Mr.A N M Alam and many others, such as Mr. A. Rahim Chowdhury, Managing Director of Arab Bangladesh Bank Ltd. Without these support, it would have been impossible to the present Petrochem (Bangladesh) Ltd. May Allah bless them all in heaven. Today, by the Grace of Allah, I am very happy that we have been able to build such a wonderful team of dedicated colleagues, both in office and the field, who can take this company to any height. We are now engaged in educating poor farmers on how to increase his income even from marginal farms. We supply high quality micronutrient fertilizer and eco-friendly latest generation Agricultural Pesticides, which are harmless to useful insects and soil borne lives such as frogs, earth worms etc. Some of them even help in releasing plant nutrients which were locked and became un-useable by plants. I feel proud to recall that we have been able to fix reasonably higher salary to our staff, compared to the Industry, besides introducing contributory Provident Fund, Life Insurance, Health Insurance, Gratuity, regular training etc., so that they feel secured and competent to perform their job. Many Internationally reputed companies are now associated with us and we enjoy the fruits of their Research & Development (RAD) work. Thus, our farmers are benefitted with the latest technologies in Crop Protection and high yielding and Hybrid Seeds. Through our reliable Officers and conveniently located Depots, we are now able to supply Fertilizers, Agricultural Pesticides and Seeds within hours to any of our more than 500 Distributors in any part of Bangladesh. Our packing are good and we do not experience any spillage, whatsoever, in transit. Germination of our seeds is always over 90% with full satisfaction of our farmers. Today, I am proud to note that Petrochem (Bangladesh) Ltd. is treated by farmers as well as by our Distributors as a company who always maintains very high quality of their products. May Allah keep this reputation of our company forever! Ameen",
  logo: [
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/PAI_8AzPgrORAA.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736692",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/solar-power-1_7EvUCZi5oh.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736723",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/petrochem_ltd_ofhjBXX3Gh.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736669",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/ppl_auerIo3acX.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736737",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/ISL_jBIZtTO7Pw.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736670",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/solar-it_b0zgamqfY.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736623",
    },
    {
      iconlogo:
        "https://ik.imagekit.io/txh5evivcha5/pclstatic/partners_logo/sisterconcernsLogo/Habitat_builders_1lBwpektj.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675921736600",
    },
  ],
};

export const logoSlider = [
  {
    id: 1,
    name: "Petro Agro Industires",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/PAI_vKXcYqQkS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416308",
  },
  {
    id: 2,
    name: "Petrochem Limited",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/petrochem_ltd_dT7wEB7aj.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416202",
  },
  {
    id: 3,
    name: "Bangla Solar IT ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-it_zChoPyztf.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416376",
  },
  {
    id: 4,
    name: "Solar Power Limited ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-power-1_M-Je0bjK6O.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416276",
  },
  {
    id: 5,
    name: "ISL",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ISL_j6F82mqMU.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416368",
  },
  {
    id: 6,
    name: "Petro Product Ltd ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ppl_6bDEpzmhT.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416274",
  },
  {
    id: 7,
    name: "Habitat builders",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/Habitat_builders_d93fNCSIv1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416281",
  },
];

export const islClientsSlider = [
  {
    id: 1,
    name: "Petro Agro Industires",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/1200px-MGI_Logo_5XPcr-4tqz.png?updatedAt=1716135592596",
  },
  {
    id: 2,
    name: "Petrochem Limited",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/atn-bangla-logo-501D1EAC7E-seeklogo.com_7dg5CqorHu.png?updatedAt=1716135592591",
  },
  {
    id: 3,
    name: "Bangla Solar IT ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/images_C0o5VQAFCZ.png?updatedAt=1716135592562",
  },
  {
    id: 4,
    name: "Solar Power Limited ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/images_gl5h0aqfpx.jpeg?updatedAt=1716135592554",
  },
  {
    id: 5,
    name: "ISL",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/images%20(2)_mOh15mmYJ.png?updatedAt=1716135592585",
  },
  {
    id: 6,
    name: "Petro Product Ltd ",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/abdul-monem-limited_4FXwCLgN6.png?updatedAt=1716135592462",
  },
  {
    id: 7,
    name: "Habitat builders",
    src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/ISL/images%20(1)_OAaTVhq_Z.png?updatedAt=1716135592550",
  },
];

export const homecardslider = [
  {
    id: 1,
    title: "Fertilizer Production",
    src: <FaRegBuilding />,
    summary:
      "We are constantly trying to improve and improvise our product through constant communication with the farmers and effort from our agronomists .",
  },
  {
    id: 2,
    title: "Biological Control",
    src: <FaBiohazard />,
    summary:
      "Due to its rich biodiversity Petrochem Bangladesh offers plenty of scope in terms of sources for natural biological control organisms as well as natural plant",
  },
  {
    id: 3,
    title: "Organic farming",
    src: <FaLeaf />,
    summary:
      "Organic foods and products are also more readily available than ever before. A 2015 study by the Organic Trade Association showed that 78 percent of...",
  },
  {
    id: 4,
    title: "Farmers Loan ",
    src: <FaMoneyBill />,
    summary:
      "We support farmer by give them fuel. Farmers will get agricultural loans, credit facilities on fertilizer goods etc from us.",
  },
  {
    id: 5,
    title: "Artificial Intelligence",
    src: <FaRobot />,
    summary:
      "With the ability to identifying the appropriate crops that a farmer should grow, crop diseases and pest, advise them on the appropriate preventive and corrective…   ",
  },
];

export const products = [
  {
    id: "recZkNf2kwmdBcqd0",
    name: "accent chair",
    image:
      "https://dl.airtable.com/.attachmentThumbnails/e8bc3791196535af65f40e36993b9e1f/438bd160",
  },
  {
    id: "recEHmzvupvT8ZONH",
    name: "albany sectional",

    image:
      "https://dl.airtable.com/.attachmentThumbnails/0be1af59cf889899b5c9abb1e4db38a4/d631ac52",
  },
  {
    id: "rec5NBwZ5zCD9nfF0",
    name: "albany table",

    image:
      "https://dl.airtable.com/.attachmentThumbnails/7478483f40a2f56662a87b304bd4e104/707d397f",
  },
  {
    id: "recd1jIVIEChmiwhe",
    name: "armchair",

    image:
      "https://dl.airtable.com/.attachmentThumbnails/530c07c5ade5acd9934c8dd334458b86/cf91397f",
  },
  {
    id: "recoM2MyHJGHLVi5l",
    name: "bar stool",
    image:
      "https://dl.airtable.com/.attachmentThumbnails/a6119fabf7256049cc0e8dbcdf536c9c/b0153f66",
  },
];

export const sisterconcerns = [
  {
    path: "/pai",
    name: "Petro Agro Industries Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/PAI_vKXcYqQkS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416308",
  },
  {
    path: "/pcl",
    name: "Petro Bangladesh Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/petrochem_ltd_dT7wEB7aj.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416202",
  },
  {
    path: "/spl",
    name: "Solar Power Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-power-1_M-Je0bjK6O.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416276",
  },
  {
    path: "/isl",
    name: "International Services Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ISL_j6F82mqMU.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416368",
  },

  {
    path: "/petroproduct",
    name: "Petro Product Bangladesh Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ppl_6bDEpzmhT.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416274",
  },
  {
    path: "/habitate",
    name: "Habitate Builders Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/Habitat_builders_d93fNCSIv1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416281",
  },
  {
    path: "/banglasolar",
    name: "Bangla solar IT ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-it_zChoPyztf.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416376",
  },
];

export const ourteam = {
  chairman: {
    name: "Mrs. Sultana Dowlah",
    designation: "Chairman of Board of Directors",
    shortsummary:
      "Mrs. Sultana Dowlah is the Chairman of Board of Directors of Petrochem (Bangladesh) Ltd. Under the dynamic leadership of Mrs. Dowlah, Petrochem has become a popular brand for the sister organizations namely Petrochem (Bangladesh) Limited, Habitat Builders Limited, Petrochem Agro Industries Limited, Bangla Solar IT Limited, International Services Limited, Petro Product Limited and Solar Power Limited. Mrs. Dowlah is the living driving force for the human resources, customers, distributors, retailers and finally products users of Petrochem the farmers of Bangladesh. Petrochem could have earned the popularity and reputation as a quality assurance products distributor of Bangladesh with national and international repute. Mrs. Dowlah has been contributing to rural and agro-economic growth of Bangladesh by helping to achieve food and nutrition security for the country. Mrs. Dowla has been very successfully engaged with various social activities and humanitarian services as a Member of Gulshan Ladies Community Club, Inner Wheel Club of Rotary Club Dhaka North and others. She is of amiable disposition, visionary, foresighted leadership capabilities for which she is a guiding umbrella for the family and society. Mrs. Dowlah loves reading, gardening, entertainment, socio-cultural activities and functions and has mountain-high ability to shoulder any responsibility and functions.",
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    email: "info@petrochembd.com",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/sultana_dowlah_QY2eVx3-H.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676442852396",
    link: "/chairman",
  },
  vicechairman: {
    name: "Mr. Asif Uddowlah",
    designation: "Vice Chairman",
    shortsummary:
      "Mr. AsifUddowlah has over 16 years’ of experience covering multidiscipline aspects of real estate, house-building, hotel management, air scouting, science & art , and most importantly commercial agricultural business on agri-inputs like seeds, fertilizers, pesticides. He did his Bachelor of Commerce from University of Dhaka& successfully acquired extra-ordinary academic qualification by completion of Diploma in Hotel Management in Switzerland. He has got a very strong foundation in his early life through acquiring Higher Secondary School Certificate and Secondary School Certificate from very organized and disciplined educational institutions namely Notre Dame College, Dhaka and BAF Shaheen School, Dhaka respectively. He has been very successfully running the commercial business of agri-inputs like seeds, fertilizers, pesticides for not only making profit for the company but for the contribution of agricultural food and nutritional security of the agrarian country like Bangladesh. He has also been contributing to help creating living room for the peace-loving people of Dhaka metropolitan city by successfully endeavor my business in the fields of Real Estate and House Building. His key qualification and leadership roles maintained as former President of Debating Club of Notre Dame College, Dhaka, former Chairman and Treasurer of Hotel Institute Montreux, Switzerland. .",
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    email: "info@petrochembd.com",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/Director_01-360x360_nBWW-mBGZ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676442852415",
    link: "/vc",
  },
  managingdirector: {
    name: "Mr. Saif Uddowlah",
    designation: "Managing Director",
    shortsummary:
      "Mr. Saif is a professional with strong analytical abilities, effective communication skills, a dedicated and a committed individual with maturity beyond his age. Always determined to reach the highest level in his chosen profession. More than eight years experience in Sales & Marketing, Information Technology in international organization in overseas countries. He completed his Masters from University of Wollongongin International Business, Business Management, and Bachelors in Commerce specializing in Business Information Systems & E-Commerce. He has taken several training on different issues from homeland and foreign countries. Mr. Saif is a truly talented individual, one of those unique blends of technical and marketing vision. He has strong leadership skill and ability to engage and mange complex projects. He always loves new challenges and innovative solution.",
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    email: "info@petrochembd.com",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/WhatsApp%20Image%202024-05-19%20at%206.16.50%20PM_NXkMUfGkO.jpeg?updatedAt=1716127209216",
    link: "/md",
  },
  gmmarketing: {
    name: "Mr. Partha Sharathi Roy",
    designation: "Excecutive Director",
    shortsummary:
      "Seventeen years of experience in Sales & Marketing in the field of agro sector. He has enormous experience in Market Development, Sales & Marketing, Field Force Management. As a member of Executive Committee, Bangladesh Crop Protection Association (BCPA) Mr. Partha also working to improve quality of life of farmers of Bangladesh. He was former Convener (2008-2010) of Safe Use of Pesticide Committee, Bangladesh Crop Protection Association (BCPA). Mr. Partha completed his Masters from Dhaka University. He has vast experience on Sales & Marketing, Field Force Management, Agro-Business, Tea Garden Management and Marketing Analysis. He has also professional Post Graduation Diploma in Tea Management. He has strong leadership, motivational skills and successfully leading Marketing & Projects Department of Petrochem (Bangladesh) Limited.",
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    email: "info@petrochembd.com",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/GM_01-360x360_6suGnPN0E1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676442852525",
    link: "/gmm",
  },
  gmfinance: {
    name: "Mr. S. M. Mozammail Hossain",
    designation: "General Manager (Finance & Administration)",
    shortsummary:
      "Mr. S. M. Mozammail Hossain is the General Manager of Finance & Administration Department. He is leading this department as professional resources person of finance sector in Bangladesh. He has more than 17 year’s experiences in Finance & Administration sector. Before joined this company he worked with United Insurance Company Ltd. He has vast experience in Financial Management & Managerial Accounting. Mr. Mozammail completed his Bachelor (Hons) & Masters from Dhaka University in Accounting and also completed Agri-Business MBA from American International University of Bangladesh (AIUB).",
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    email: "info@petrochembd.com",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/GM-360x360_pnYul2vP_.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676442852507",
    link: "/gmf",
  },
};

export const recruitments = [
  {
    id: "001",
    jobtitle: "Call Center Executive",
    companyname: "Petrochem Group",
    department: "Marketing",
    location: "Dhaka Head Office",
    jobtype: "Probitional",
    jobdescription: [
      {
        res: "Provide technical assistance to farmers through call center",
      },
      {
        res: "Preparing report on a regular basis",
      },
      {
        res: "Monitoring the progress of field activities",
      },
      {
        res: "Deliver technical support to dealers and retailers",
      },
      {
        res: "Coordinate with the field staff to execute different campaign according to the plan",
      },
      {
        res: "Promote company’s products through call center",
      },
      {
        res: "Prepare farmers data base",
      },
    ],
    joblink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeKyThYC4bTZrEyaRAQx4WiB3RIsCmkXrjnBHuCsQDSUw7h0A/viewform",
    companylogo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/logo-green-1_HZr7sZqID.png?ik-sdk-version=javascript-1.4.3&updatedAt=1676527318106",
    circulardate: "27-10-2022",
    recruitments: {
      req1: "Master’s/ Graduates in Fisheries / Zoology.",
      req2: "At least 4 years’ working experience in fisheries sector (NGO or Private sector).",
    },
    sector: "Fish",
    salary: "As per the company Policy ",
    jobduration: "8 Months from November 2022",
  },
  {
    id: "002",
    jobtitle: "Aquaculture Specialist",
    companyname: "Petrochem Group",
    department: "Marketing",
    location: "Jessore",
    jobtype: "Probitional",
    jobdescription: [
      {
        res: "Provide technical support to One Stop Service Providers and WMF",
      },
      {
        res: "Provide technical support to sales officers",
      },
      {
        res: "Execute monthly plan to conduct the activity given by the company",
      },
      {
        res: "Preparing report on a regular basis",
      },
      {
        res: "Responsible for project implementation",
      },
      {
        res: "Conduct Training the staff, dealer, retailer and farmer",
      },
      {
        res: "Monitoring the progress of field activities",
      },
      {
        res: "Deliver technical support to farmers",
      },
      {
        res: "Prescribe company’s product",
      },
    ],
    joblink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeKyThYC4bTZrEyaRAQx4WiB3RIsCmkXrjnBHuCsQDSUw7h0A/viewform",
    companylogo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/logo-green-1_HZr7sZqID.png?ik-sdk-version=javascript-1.4.3&updatedAt=1676527318106",
    circulardate: "27-10-2022",
    recruitments: {
      req1: "Master’s/ Graduates in Fisheries / Zoology.",
      req2: "At least 4 years’ working experience in fisheries sector (NGO or Private sector).",
    },
    sector: " Fish",
    salary: "As per the company Policy",
    jobduration: "8 Months from November 2022",
  },
  {
    id: "003",
    jobtitle: "Technical Support Officer",
    companyname: "Petrochem Group",
    department: "Marketing",
    location: "Jessore, Khulna, Faridpur",
    jobtype: "Probitional",
    jobdescription: [
      {
        res: "Provide technical assistance to One Stop Service Providers and WMF",
      },
      {
        res: "Preparing field report on a regular basis",
      },
      {
        res: "Prepare data base of farmers",
      },
      {
        res: "Conduct Training the staff, dealer, retailer and farmer",
      },
      {
        res: "Coordinate with the field staff to execute different campaign according to the plan",
      },
      {
        res: "Explore new area of aqua product’s business",
      },
      {
        res: "Deliver technical assistance to farmers group",
      },
      {
        res: "Prescribe company’s product",
      },
    ],
    joblink:
      "https://docs.google.com/forms/d/e/1FAIpQLSeKyThYC4bTZrEyaRAQx4WiB3RIsCmkXrjnBHuCsQDSUw7h0A/viewform",
    companylogo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/logo-green-1_HZr7sZqID.png?ik-sdk-version=javascript-1.4.3&updatedAt=1676527318106",
    circulardate: "",
    recruitments: {
      req1: "Master’s/ Graduates in Fisheries / Zoology.",
      req2: "At least 4 years’ working experience in fisheries sector (NGO or Private sector).",
    },
    sector: "Fish",
    salary: "As per the company Policy ",
    jobduration: "8 Months from November 2022",
  },
];

export const sisterconcernsdetails = {
  pai: {
    path: "/pai",
    name: "Petro Agro Industries Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/PAI_vKXcYqQkS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416308",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/1556036536__1__vC6ofppbE.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537169460",
    tagline: "significant presence in the Agro and Seed Development  sector ",
    summary:
      "Petrochem Agro Industries is a Private Limited Company established in August 13, 1990. Vision of Petrochem Agro Industries Limited is to play a leading role in improving the quality of life and well being of the farmers of Bangladesh through responsible application of scientific knowledge and modern skills. We are dedicated to handover better-quality agro inputs to our end users. The team of Petrochem Agro Industries Limited is ensuring superior quality micro-nutrient fertilizers, pesticides, Herbicides, fungicides, plant growth regulators and seeds for agricultural growth of Bangladesh. Our Pesticide Factory is at BSCIC Industrial area Keranigonj. All pesticides are packed and Re-packed and distribution is done from here. It is very near to Dhaka. Public transport facilities are very convenient from here.",
    mision: "",
    vision: "",
    extrasummary:
      "Petrochem Agro Industries Limited has Research and Development (R&D) division to develop the products which has good potential and demand in the market. R&D division conducts trials of different products in various location of Bangladesh. We communicate with different Govt. agency of Bangladesh on regular basis for product registration, and other regulatory matters.",
  },
  pcl: {
    path: "/pcl",
    name: "Petrochem Bangladesh Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/petrochem_ltd_dT7wEB7aj.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416202",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/PCL_T7EE1oLAc.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537363068",
    tagline: "Private Limited Company established in August 13, 1990",
    summary:
      "Petrochem (Bangladesh) is a Private Limited Company established in August 13, 1990. Petrochem’s vision is to play a leading role in improving the quality of life and well being of the farmers of Bangladesh through responsible application of scientific knowledge and modern skills. We are dedicated to market superior quality of micro-nutrient fertilizers, pesticides, Herbicides, fungicides, plant growth regulators and seeds for agricultural growth of Bangladesh. Our mission is to achieve business excellence through quality by understanding, accepting, meeting and exceeding customer expectations. Petrochem follows International standard on quality management system to ensure consistent quality of product and service to achieve customers’ satisfaction. Petrochem also meets all national regulatory requirements relating to its current business. The management of Petrochem has “quality” as prime consideration in all its business decisions. All employees of Petrochem must follow documented procedures to ensure compliance with quality and standard. The pool of human resources of the company will be developed to their full potential and harnessed through regular training, participation in seeking continuous improvement in working environment.",
    mision: "",
    vision: "",
    extrasummary:
      "Petrochem (Bd) Limited is committed to maintain the harmonious balance of the eco-system and therefore constantly seeks ways to use pesticide and fertilizer judiciously. We give training to farmers and retailers on the safe use of pesticide. We also create awareness on environment issues amongst our employees and associates. We are committed to employ excellent staff and create an efficient nation-wide distribution network in order to make all our products readily available to the end users. Through regular Farmers’ and Distributors’ training, we are educating them on modern agricultural practices. We will continue to expand our product lines, be innovative in marketing strategies and also be consistent in maintaining high quality of products and services to sustain our reputation as one of the leading Agrochemical marketing Company in Bangladesh.",
  },
  spl: {
    path: "/spl",
    name: "Solar Power Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-power-1_M-Je0bjK6O.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416276",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/photo-1521618755572-156ae0cdd74d_wFiz0x5qb.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676536774953",
    tagline: "significant presence in the energy sector ",
    summary:
      "Solar Power Limited has a significant presence in the energy sector of Bangladesh and offers a wide range of renewable and conventional energy solutions. Solar Power is a future looking manufacturing outfit aimed to serve the energy needs of the future. Solar Power Limited is a sister concern of Petrochem (Bangladesh) Limited. Petrochem (Bangladesh) Limited. is one of the leading agriculture companies in Bangladesh.  This company is in business for the last 25 years and has an employee of 350+ people.  Our main source of business is Agriculture, Real Estate and other indenting business. Solar business is a new segment in our business portfolio",
    mision:
      "Establishing our national identity in the world by our innovative success. We are committed to providing the highest quality product at a competitive price and services exceeding our customer expectations through continual improvement and innovation, system and highly trained technical personnel.",
    vision:
      "Solar Power’s vision is to play a leading role in reducing the greenhouse effect, saving the cost of energy and improving the quality of life in Bangladesh. We facilitate world class renewable energy solutions by utilizing different technology expertise from country and abroad working in the field of energy saving. We are dedicated to market superior quality of LED Indoor and outdoor lighting, Solar Powered Irrigation System, Solar Home System, Solar Grid System, Solar Power Generation Plant. We are committed to providing the highest quality product at a competitive price and services exceeding our customer expectations through continual improvement and innovation, system and highly trained technical personnel.",
    extrasummary:
      "Solar power Limited. is providing every solution related to sunlight, such as Module Design and construction of the Solar Power Plant Systems, maintenance and consulting. Solar water pump installing. We are very pragmatic when evaluating a solar application.",
  },
  petroproduct: {
    path: "/petroproduct",
    name: "Petro Product Bangladesh Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ppl_6bDEpzmhT.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416274",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/zbynek-burival-GrmwVnVSSdU-unsplash_r4GyvYfog.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537536118",
    tagline: "Significant presence in the Petroleum sector ",
    summary:
      "Petro Products (Bangladesh) Limited is a private limited company, established in August 13, 1990. This company imports Petroleum, Octane, Diesel, Petrochemical and sales all over the country as an agent of foreign principal company. Petro Products (Bangladesh) Limited can import all kinds of motor oil, mobile oil, lubricant, agrochemical, pharmaceutical chemical from foreign companies as well as foreign principals companies.",
    mision: "",
    vision: "",
    extrasummary: "",
  },
  habitate: {
    path: "/habitate",
    name: "Habitate Builders Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/Habitat_builders_d93fNCSIv1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416281",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/tierra-mallorca-rgJ1J8SDEAY-unsplash_Ezv6AG6V-.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537600585",
    tagline: "significant presence in the energy sector ",
    summary:
      "Habitat Builders Limited is a private limited company, engaged in building residential flats, offices & shopping complex.Habitat Builders Ltd is a private limited company, engaged in building residential flats, offices & shopping complex. Habitat Builders is one of the modern real estate companies who are developing exclusive   apartments in residential area. Our all projects are green environment friendly. We are dedicated to provide best materials, service to ensure standard quality. We have successfully handover following projects to our customers.",
    mision: "",
    vision: "",
    extrasummary: "",
  },
  isl: {
    path: "/isl",
    name: "International Services Ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/ISL_j6F82mqMU.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416368",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/studyabroad_X_FszzDoKO.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537795636",
    tagline: "significant presence in the Service sector ",
    summary:
      "International Services (Bangladesh) Limited is a private limited company, established in August 13, 1990. This company is engaged to serve as a local agent of international /multinational/ foreign companies. This company provides services to principal /foreign companies through export, import, indenting, international agreement, international builders, construction, engineering plan, design etc. International Services (Bangladesh) Limited is one of the successful business platforms where foreign; multinational companies; international organizations can avail diversified business supports. We are dedicated to provide best and effective supports to our valued clients. The Company has developed a pool of, dedicated, trained, skilled and professionally sound human resources to discharge their duties in maintaining state of the art.",
    mision:
      "In the long journey of professionalism, technological endeavor and leadership in the trade and business of diversified fields Mr. Siraj Uddowlah could have successfully earned reputation and popularity in home and abroad. His working experiences are in the fields of Agriculture, Seeds, Fertilizers, Pesticides, Tea, Oil, Real Estate, Education, Social Welfare and many others.",
    vision:
      "Mr. A. B. A. Siraj Uddowlah is Managing Director of the Company. Academically he is educated in the field of Agricultural Sciences in home and abroad. He is experienced in diversified line of professionalism, trade and businesses.  He started his service career in 1963 as Manager, James Finlay’s Tea Garden at Srimongol. He was Resident Director of Sarma Chemical Works and Huqson’s Laboratories, Comilla, from 1968-75. Mr. Dowlah led The Shell Company of Bangladesh Ltd as Managing Director from 1976 to 1990",
    extrasummary: "",
  },
  banglasolar: {
    path: "/banglasolar",
    name: "Bangla solar IT ltd",
    logo: "https://ik.imagekit.io/txh5evivcha5/pclstatic/Sister_concern_logo/solar-it_zChoPyztf.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676177416376",
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/thisisengineering-raeng-32PpagSzeGs-unsplash_GkVvdZoJ6S.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676537594844",
    tagline: "Next is now ",
    summary:
      " Bangla Solar IT Limited is a private limited company, established in August 13, 1990 as Bangla Politian Limited. From 2015 it is operated as Bangla Solar IT Limited. We are dedicated to market superior quality, cost effective, environmental friendly and sustainable green energy solution, LED lighting, IT equipments. We have dedicated skilled field force who are ready to provide before and after sales and technical service all over Bangladesh",
    mision: "",
    vision: "",
    extrasummary: "",
  },
};

export const testislider = [
  {
    id: 1,
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/happy-moment-abdul-malek-babul-1-300x300_bIWhY_eRxv.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676779331853",
    title: "Farmers",
    name: "মো আজহার মোল্লা",
    src: <FaRegBuilding />,
    comments:
      "I've used Petrochem seeds and pesticides for years and am very satisfied. The seeds are high quality, grow quickly, and produce a good yield. The pesticides effectively control pests. I highly recommend Petrochem products.",
  },
  {
    id: 2,
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/DPP_u0002-300x300_IbYkl1y-h.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676779331833",
    title: "Farmers",
    name: "করিম উদ্দিন",
    src: <FaBiohazard />,
    comments:
      "Petrochem seeds and pesticides are a game-changer. They're competitively priced, and the crops grow faster and healthier. The pesticides are long-lasting, saving me money. I'm very happy with Petrochem products.",
  },
  {
    id: 3,
    photo:
      "https://ik.imagekit.io/txh5evivcha5/pclstatic/happy-farmer-char-640-300x300_JbFJs6EGnf.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676779331161",
    title: "Farmers",
    name: "জয়নাল আবেদীন",
    src: <FaLeaf />,
    comments:
      "Petrochem seeds and pesticides have significantly improved my harvest. The seeds are disease and pest-resistant, and the pesticides are effective. My crop quality has improved, and I get better prices in the market. I highly recommend Petrochem products.",
  },
];

export const homemissionvision = {
  title: "Welcome to Petrochem Bangladesh Limited.",
  subtitle:
    "Petrochem (Bangladesh) is a Private Limited Company established in August 13, 1990.",
  mission:
    "Our mission is to achieve business excellence through quality by understanding, accepting, meeting and exceeding customer expectations. Petrochem follows International standard on quality management system to ensure consistent quality of product and service to achieve customers’ satisfaction.",
  vision:
    "Petrochem’s vision is to play a leading role in improving the quality of life and well being of the farmers of Bangladesh through responsible application of scientific knowledge and modern skills. We are dedicated to market superior quality of micro-nutrient fertilizers, pesticides, Herbicides, fungicides, plant growth regulators and seeds for agricultural growth of Bangladesh.",
  support:
    "We give training to farmers and retailers on the safe use of pesticide.",
  regulation:
    "Petrochem also meets all national regulatory requirements relating to its current business.",
};

export const corpcarddata = [
  {
    title: "Crop Management",
    icon: <MdAltRoute className="inline-block text-5xl" />,
    details:
      "Petrochem Serves Crop Management Tools and System to the end users and Farmers.",
  },
  {
    title: "Agro Processing",
    icon: <MdLightbulbOutline className="inline-block text-5xl" />,
    details:
      "Agro processing is very new initiative by Petrochem (Bangladesh) Limited",
  },
  {
    title: "Pest Management",
    icon: <MdOutlineBugReport className="inline-block text-5xl" />,
    details:
      "PCL prefer to serve Pest Management Service to all farmer to grow them double.",
  },
  {
    title: "Diseases Management",
    icon: <MdDataExploration className="inline-block text-5xl" />,
    details:
      "Diseases Management tools is to core for smart farming and growth farming.",
  },
];

export const pclmap = {
  data: {
    title:
      "We have 20,000+ farmers Network & large number of distributor chain .",
    desc: "We have spent 30 years working with Bangladeshi farmers. Petrochem follows International standard on quality management system to ensure consistent quality of product and service to achieve customers’ satisfaction. We are now expanding to International markets.",
    zonecoverage: "Zone Coverage",
    zonecoveragedesc:
      "We are covered almost 65% District of Bangladesh. We have 20,000+ Farmers Network throughout the country.",
    satisfiction: "Satisfaction",
    satisdesc:
      "All of our farmers are satisfied with our products quality , support and service.",
  },
};

export const gallaryalbum = {
  teamphotos: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/11885766_10206058877245995_7230965478090577387_o_jG4q23h0Ic.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1676779334838",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/opp_wGnUd5gCK.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675244270963",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/bgteam_zjQadAwp1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675239114159",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/288183640_10223371523051320_4384149914264238547_n_kLQyLJ8DH.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152288461",
    },
  ],
  culturalprogram: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/280308516_1312330542590187_7668475518416950941_n_u3VdpG4_T.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150077352",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/11884653_10206058944687681_3286439666051499936_o_o0HDRD_dKH.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152278911",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/11895141_10206058954887936_8630746175417721628_o_0prFkqFw9p.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152279108",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/299699344_915791281969_3282358990820404298_n_nzRrYdNlJ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150077436",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/23737977_10212148094712626_848256625887482586_o_Y7B6mHKz3E.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150072834",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/23668798_10212148083712351_4132915190239355155_o_48kO0oh2e.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150072389",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/23593704_10212148084152362_7655097602575800711_o_o7pI_rKi5.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150072390",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/13692713_10154452992718678_9051308369071034436_n_zQ1HDjbz2F.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152282737",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/305808585_10223711836958955_1102339982369289147_n_9z-bRefpV8.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152281032",
    },
  ],
  csr: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/106472232_10219264394375670_6414369664162389962_n_vBBbfE9oaK.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152285830",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/106673060_10219264394815681_4395679276094094902_n_nmcaT1zIyD.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152285835",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/bangladesh-educational-curriculum-300x300_W0qHV8CPjZ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1675855121215",
    },
  ],
  farmers: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/275787327_10222920773182855_6481897336364225561_n_vXpvMkX03G.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152285630",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/275808382_10222920773862872_2902352571505155538_n_UKIr_pyxS.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152283818",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/275730047_10222920770342784_4141228035488122844_n_tBCQM7xFQ3.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152282895",
    },
  ],
  meeting: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/275788743_10222920774662892_400332274300175529_n_EtSt0dzpN.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152282781",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/329911013_882338933037406_3320389964896127656_n_PsJjt6X6-.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152282849",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/329571648_1216623475898105_5748266769000174131_n_v0ZYYIEZYL.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150073492",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/329264721_739310084297208_1898139692834638948_n_x-94jHmxX.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150074580",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/288460671_10223371522411304_691142222252626073_n_2VseAl9P5W.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152288807",
    },
  ],
  gettogather: [
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/280252941_1312330635923511_848494422105663230_n_mKSmZSL2_.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150075787",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/305808585_10223711836958955_1102339982369289147_n_9z-bRefpV8.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152281032",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/299777178_915791187159_2460360012214680684_n_-IFd3JX4oO.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677150073117",
    },
    {
      src: "https://ik.imagekit.io/txh5evivcha5/pclstatic/gallerypictures/21761599_766126930529_3917277140966379348_n_usqnrIwsq.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677152281989",
    },
  ],
};

export const footerdata = {
  leftdata: {
    address:
      "ABC Heritage (3rd Floor),Plot No. 2 & 4, Jashim Uddin Avenue Sector-3, Uttara C/A, Dhaka-1230, Bangladesh",
    phone: "88 - 0248961701-3",
  },
  linkdata: [
    {
      linkname: "Who we are",
      linkpath: "whoweare",
    },
    {
      linkname: "About us",
      linkpath: "about-us",
    },
    {
      linkname: "Our team",
      linkpath: "our-team",
    },
    {
      linkname: "Mission & Vision",
      linkpath: "mission",
    },
    {
      linkname: "CSR",
      linkpath: "csr",
    },
    {
      linkname: "Partners",
      linkpath: "our-partners",
    },
    {
      linkname: "Contact",
      linkpath: "contact-us",
    },
    {
      linkname: "Careers",
      linkpath: "career",
    },
    {
      linkname: "Sustainability",
      linkpath: "sustainability",
    },
    {
      linkname: "Sister Concerns",
      linkpath: "sister-concern",
    },
  ],
};
